export const CNPJ_MASK = 'XX.XXX.XXX/XXXX-##'
export const CNPJ_FORMAT_REGEX = /^[0-9A-Za-z]{2}\.[0-9A-Za-z]{3}\.[0-9A-Za-z]{3}\/[0-9A-Za-z]{4}-[0-9]{2}$/
export const CNPJ_FORMAT_ERROR = 'Este campo deve estar no formato xx.xxx.xxx/xxxx-xx'
